import { Fragment, useEffect, useState } from 'react';
import styled from 'styled-components';
import { theme } from './character_count.theme';

export interface CharacterCountProps {
	value: string;
	limit?: number;
	alwaysShow?: boolean;
}

const elements = {
	characterCount: styled.div`
		margin-left: auto;
		margin-top: ${theme.getValue('baseMarginTop')};
		font: ${theme.getValue('baseText')};
		color: ${theme.getValue('baseTextColor')};

		&[data-state-max-length-exceeded='true'] {
			color: ${theme.getValue('invalidTextColor')};
		}
	`,
};

export function CharacterCount({ limit, value, alwaysShow = false }: CharacterCountProps): JSX.Element {
	const [count, setCount] = useState(value?.length ?? 0);

	useEffect(() => {
		setCount(value?.length ?? 0);
	}, [value]);

	return (
		<Fragment>
			{alwaysShow || (limit !== undefined && count > limit) ? (
				<elements.characterCount data-state-max-length-exceeded={limit !== undefined && count > limit}>
					{count}/{limit}
				</elements.characterCount>
			) : null}
		</Fragment>
	);
}
